<style>
.showPerfil {
    cursor: pointer;
    border-bottom: 1px dotted;
}
</style>
<template>
<div id="page-usuarios" >
    <div>
        <v-breadcrumbs :items="breadcrumbs" >
            <v-icon slot="divider" >forward</v-icon>
        </v-breadcrumbs>
    </div>
    <v-container fluid fill-height>
        <v-layout align-center justify-center>
            <v-flex xs12>
                <base-material-card color="primary" icon="library_books" title="Administrar Usuarios de Clientes" class="elevation-1 px-5 py-3" >
                       <v-card-actions>
                     <v-spacer></v-spacer>
                            <v-btn x-small fab dark color="green" title="Exportar"  @click="exportar()" v-tippy>
                                    <v-icon dark>mdi-table</v-icon>
                            </v-btn>
                            <v-dialog v-model="modal_exportar" max-width="40%" >
                                <v-card>
                                  
                                    <v-card-text>
                                        <h2>El reporte se generó exitosamente.</h2><p/><p/>
                                        <center>
                                         <exportar-excel v-if="aexportar.length>0"  :data="aexportar" :exportFields="camposexcel" name="UsuariosCliente.xlsx" >
                                            <v-btn  dark color="success" title="Descargar"  v-tippy @click="modal_exportar=false" >
                                                <v-icon dark>mdi-ok</v-icon> Aceptar
                                        </v-btn>
                                        </exportar-excel>
                                         </center>
                                    </v-card-text>
                                </v-card>
                            </v-dialog>
                           
                            <br />
                            
                     </v-card-actions>
                    <v-card-text>
                        <div id="datagrid" v-on:keyup.enter="$refs.pagination_pw.filterData()" >

                            <v-client-table ref="vuetable" :data="usuarios.items" :columns="columns" :options="options" class="elevation-2 pa-2" >
                                <template slot="noResults" >
                                    <v-alert :value="true" icon="info" color="info" >No se encontro ningun registro</v-alert>
                                </template>
                                <template slot="nombre" slot-scope="props" >
                                    <span>{{ props.row.nombre }}</span>
                                </template>

                                <template slot="perfil" slot-scope="props" >
                                    <div v-if="props.row.perfil !== null" @click="openModalPermisos(props.row.perfil)" :class="['showPerfil']" >
                                        {{ getNombrePerfil(props.row.perfil) }}
                                    </div>
                                    <div v-else>Administrador</div>
                                </template>
                                <template slot="subtipo" slot-scope="props" >                                    
                                        {{ getSubtipo(props.row.subtipo) }}                                    
                                </template>
                                <template slot="estatus" slot-scope="props" >
                                    <div v-if="props.row.estatus==1" >Activo</div>
                                    <div v-if="props.row.estatus==0" >Inactivo</div>
                                </template>
                                <template slot="estatus_rfc" slot-scope="props" >
                                    <div v-if="props.row.estatus_rfc==1" >Activo</div>
                                    <div v-if="props.row.estatus_rfc==0" >Inactivo</div>
                                    <div v-if="props.row.estatus_rfc==-1" >Sin Asignar</div>
                                </template>

                                <template slot="actions" slot-scope="props" >
                                    <v-speed-dial direction="left" open-on-hover>
                                        <template v-slot:activator>
                                            <v-btn x-small fab dark color="primary" >                                                
                                                <v-icon>reorder</v-icon>
                                            </v-btn>
                                        </template>
                                        <v-btn v-if="props.row.cliente_id==null" x-small fab dark color="blue" @click.native="
                                            openModalCliente(props.row.id, props.row.nombre, props.row.apellidos)
                                            " title="Asignar empresa/cliente" v-tippy>
                                            <v-icon>business</v-icon>
                                        </v-btn>

                                        <v-btn x-small fab dark color="info" @click.native="
                                            openModalGrupo(props.row.id, props.row.nombre, props.row.apellidos)
                                            " title="Cambiar a Grupo" v-tippy>
                                            <v-icon>group_add</v-icon>
                                        </v-btn>
                                        
                                        <v-btn x-small fab dark color="green" v-if="props.row.estatus==0" @click.native="changeEstatus(props.row.id, props.row.id_usuario_cliente, true)" title="Activar Usuario" v-tippy>
                                            <v-icon>check</v-icon>
                                        </v-btn>
                                        <v-btn x-small fab dark color="orange" v-if="props.row.estatus==1" @click.native="changeEstatus(props.row.id, props.row.id_usuario_cliente, false)" title="Desactivar Usuario" v-tippy>
                                            <v-icon>block</v-icon>
                                        </v-btn>                                        
                                        
                                        <v-btn x-small fab dark color="indigo" @click.native="
                                            resetPassword(props.row.id, props.row.cliente_id, props.row.email)
                                            " title="Resetear Contraseña" v-tippy>
                                            <v-icon>lock</v-icon>
                                        </v-btn>

                                        <v-btn x-small fab dark color="purple" @click.native="
                                            logout(props.row.id)
                                            " title="Cerrar Sesión" v-tippy>
                                            <v-icon>report_problem</v-icon>
                                        </v-btn>

                                        <v-btn x-small fab dark color="blue" @click.native="getUsuario(props.row.id, props.row.id_usuario_cliente)" title="Editar Registro" v-tippy>
                                            <v-icon>edit</v-icon>
                                        </v-btn>

                                    </v-speed-dial>
                                </template>
                            </v-client-table>
                            <template>
                                <div v-if="pwPagination.total > 0" >
                                    <div class="mt-3" >
                                        <PaginacionComponent ref="pagination_pw" :total='pwPagination.total' :links="pwPagination.links" :items="usuarios" :options="pwPagination.options" ></PaginacionComponent>
                                    </div>
                                </div>
                            </template>
                        </div>
                    </v-card-text>
                </base-material-card>
            </v-flex>
        </v-layout>
    </v-container>   

    <v-dialog v-model="modal_permisos" max-width="40%" >
        <v-card>
            <v-card-title>
                <v-card class="primary white--text titulomodal" >
                    <v-icon @click.native="modal_permisos = false" class="white--text" >cancel</v-icon>&nbsp;
                    <span class="subheading" >
                        <strong>{{ titleModalPermisos }}</strong>
                    </span>
                </v-card>                
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text>
                <v-data-table :items="permisos_perfiles" class="elevation-1" :headers="permisos.headers" >
                    <template slot="no-data" >
                        <v-alert :value="true" color="error" icon="warning" >
                            No hay permisos en este perfil...
                        </v-alert>
                    </template>

                    <template slot="items" slot-scope="permiso" >
                        <td>{{ permiso.item.categoria }}</td>
                        <td>{{ permiso.item.nombre }}</td>
                    </template>
                </v-data-table>
            </v-card-text>
        </v-card>
    </v-dialog>

    <v-dialog v-model="modal_grupo" max-width="40%" >
        <v-card>
            <v-card-title>
                <v-card class="primary white--text titulomodal" >
                    <v-icon class="white--text" >reorder</v-icon>&nbsp;
                    <span class="subheading" >
                        <strong>Cambiar usuario a grupo</strong>
                    </span>
                </v-card>
                <v-spacer></v-spacer>
                <v-btn icon @click.native="modal_grupo = false" class="close_modal" >
                    <v-icon class="white--text" >cancel</v-icon>
                </v-btn>
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text>
                <v-form ref="formGrupo" lazy-validation="" >
                    <v-container>
                        <v-layout>
                            <v-flex xs12>
                                Cambiar usuario: {{nombre_usuario_seleccionado}} a grupo.
                            </v-flex>
                        </v-layout>
                        <v-layout>
                            <v-flex xs12>
                                <v-select :items="grupos" v-model="id_grupo" item-text="nombre" item-value="id_grupo" label="Seleccione Grupo" required 
                                :rules="[rules.required]" >
                                </v-select>
                            </v-flex>
                        </v-layout>
                    </v-container>
                </v-form>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn @click.native="modal_grupo = false" >
                    <v-icon>cancel</v-icon> Cancelar
                </v-btn>
                <v-btn color="success" @click.native="convertirUsuario()" >
                    <v-icon>done</v-icon>Guardar
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
    <v-dialog v-model="modal_cliente" max-width="40%" >
        <v-card>
            <v-card-title>
                <v-card class="primary white--text titulomodal" >
                    <v-icon class="white--text" >reorder</v-icon>&nbsp;
                    <span class="subheading" >
                        <strong>Asignar empresa/cliente a usuario</strong>
                    </span>
                </v-card>
                <v-spacer></v-spacer>
                <v-btn icon @click.native="modal_cliente = false" class="close_modal" >
                    <v-icon class="white--text" >cancel</v-icon>
                </v-btn>
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text>
                <v-form ref="formCliente" lazy-validation="" >
                    <v-container>
                        <v-layout>
                            <v-flex xs12>
                                Asignar empresa/cliente a usuario: {{nombre_usuario_seleccionado}}.
                            </v-flex>
                        </v-layout>
                        <v-layout>
                            <v-flex xs12>
                                <v-select :items="clientes" v-model="id_cliente" item-text="nombre" item-value="id_cliente" label="Seleccione Cliente" required 
                                :rules="[rules.required]" >
                                </v-select>
                            </v-flex>
                        </v-layout>
                    </v-container>
                </v-form>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn @click.native="modal_cliente = false" >
                    <v-icon>cancel</v-icon> Cancelar
                </v-btn>
                <v-btn color="success" @click.native="convertirUsuarioCliente()" >
                    <v-icon>done</v-icon>Guardar
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>

    <v-dialog v-model="modal" max-width="500px" >
        <v-card>
            <v-card-title>
                <v-card class="primary white--text titulomodal" >
                    <v-icon @click.native="modal = false" class="white--text">cancel</v-icon>&nbsp;
                    <span class="subheading" >
                        <strong>Actualizar Usuario</strong>
                    </span>
                </v-card>
                <v-spacer></v-spacer>
                <v-btn icon @click.native="modal = false" class="close_modal" >
                    <v-icon class="white--text" >cancel</v-icon>
                </v-btn>
            </v-card-title>
            
            <v-card-text>
                <v-form ref="form" lazy-validation>
                    <v-container grid-list-md @keyup.enter="updateUsuario()">
                        <v-layout wrap>
                            <v-flex xs12>
                                <v-text-field label="Nombre" v-model="model.nombre" :rules="[rules.required]" ></v-text-field>
                            </v-flex>
                        </v-layout>
                        <v-layout wrap>
                            <v-flex xs12>
                                <v-text-field label="Apellidos" v-model="model.apellidos" :rules="[rules.required]" ></v-text-field>
                            </v-flex>
                        </v-layout>
                        <v-layout wrap>
                            <v-flex xs12>
                                <v-text-field label="Iniciales" v-model="model.iniciales" @input="model.iniciales = model.iniciales.toUpperCase()" maxlength=15 :rules="[rules.required]" ></v-text-field>
                            </v-flex>
                        </v-layout>
                        <v-layout wrap>                            
                            <v-flex xs12>
                                <v-select :items="tipos_usuario_select" v-model="model.tipo_usuario" label="Tipo de Usuario" item-text="nombre" item-value="id_tipo_usuario" :rules="[rules.required]"></v-select>
                            </v-flex>
                            <v-flex xs12 v-show="model.tipo_usuario == 2">
                                <v-select :items="perfiles" v-model="model.perfil" item-text="nombre" item-value="id_perfil" label="Perfil" ></v-select>
                            </v-flex>
                            <v-flex xs12>
                                <v-select :items="notificaciones_list" v-model="model.notificaciones" label="Notificaciones" 
                                    :rules="[rules.required]" ></v-select>
                            </v-flex>
                        </v-layout>
                    </v-container>
                </v-form>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn @click.native="modal = false" >
                    <v-icon>cancel</v-icon> Cancelar
                </v-btn>
                <v-btn color="success" @click.native="updateUsuario()" >
                    <v-icon>done</v-icon> Actualizar                    
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
   
</div>

</template>

<script>
import axios from "axios";
import moment from "moment";
import PaginacionComponent from '@/components/PaginacionComponent.vue';
import Pagos from '../clientes/Pagos.vue';

export default {
    components: {
        "PaginacionComponent": PaginacionComponent
    },    
    data() {
        return {
            tipos_usuario_select: [{
                    id_tipo_usuario: 1,
                    nombre: "Administrador"
                },
                {
                    id_tipo_usuario: 2,
                    nombre: "Usuario"
                }
            ],
            tipos_usuario: [0],
            notificaciones_list:["Pendiente", "Si", "No"],
            fab: [],
            modal_exportar: false,
            model_filters: '',
            aexportar: [],
            camposexcel:{
                "Nombre": "nombre" ,
                "Apellidos": "apellidos",
                "RFC o TAX ID": "cliente_rfc",   
                "Razón Social": "cliente", 
                "Email": "email",                    
                "Perfil": "perfil",
                "Notificaciones":"notificaciones",
                "Estatus": "estatus",
                "Estatus del RFC":"estatus_rfc",
            },
            pwPagination: {
                total: 0,
                links: {                                        
                    url: this.$hostname + "usuarios/getall_usuarios_clientes/",                    
                    next: '',
                    prev: '',
                },
                options: {
                    tipo: 1,
                    size: 10,
                    loading: this.showLoading,
                    filters: {}
                }
            },
            columns: [   
                "iniciales",  
                "nombre",
                "apellidos",
                "cliente",
                "cliente_rfc", 
                "email",                
                "perfil",
                "notificaciones",                
                "estatus",
                "estatus_rfc",
                "actions"
            ],
            show_loading: true,
            
            options: {
               filterable: ["iniciales","cliente","cliente_rfc","nombre", "apellidos","notificaciones", "email"],
                sortable: [],
                filterable: true,
              //  filterByColumn: false,
          /*       texts: {
                            filter: '',
                            filterPlaceholder: 'Buscar',
                        }, */
                headings: {
                    iniciales:"Iniciales",
                    nombre: "Nombre",
                    apellidos: "Apellidos",
                    cliente_rfc:"RFC o TAX ID",   
                    cliente:"Razón Social", 
                    email: "Email",                    
                    perfil: "Perfil",
                    estatus: "Estatus",
                    estatus_rfc: "Estatus RFC",
                    actions: "Operaciones"
                },
                initFilters: {"estatus":1},
                listColumns: {
                    estatus: [{
                            id: 1,
                            text: "Activos"
                        },
                        {
                            id: 0,
                            text: "Inactivos"
                        },                        
                    ],
                    estatus_rfc: [{
                            id: 1,
                            text: "Activos"
                        },
                        {
                            id: 0,
                            text: "Inactivos"
                        },{
                            id:-1,
                            text: "Sin Asignar"
                        }                       
                    ],
                    notificaciones: [
                        {
                            id: "Pendiente",
                            text: "Pendiente"
                        },
                        {
                            id: "Si",
                            text: "Si"
                        },
                        {
                            id: "No",
                            text: "No"
                        },                        
                    ],
                }
            },
            breadcrumbs: [{
                    text: "Inicio",
                    disabled: false,
                    to: "/admin"
                },                
                {
                    text: "Usuarios Cliente",
                    disabled: true,
                    href: ""
                }
            ],
            title: "",
            titleModalPermisos: "",                        
            modal_permisos: false,            
            update: false,
            modal:false,
            modal_cliente: false,
            clientes: [],
            id_cliente: "",

            modal_grupo: false,
            grupos: [],
            id_grupo: "",
            id_usuario_seleccionado: "",
            nombre_usuario_seleccionado: "",
            rules: {
                required: v => !!v || "Este campo es requerido", 
                email: value => {
                    const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                    return pattern.test(value) || "Correo electrónico no valido";
                },               
            },

            perfiles: [],
            model: {
                id_usuario: "",
                username: "",                
                nombre: "",
                apellidos: "",
                tipo_usuario:"",
                iniciales:"",  
                notificaciones:"Pendiente",              
                perfil: "",      
                cliente:"",
                id_usuario_cliente:"",          
            },
            
            search: "",
            usuarios: {                            
                items: [{
                    perfil: 0
                }]
            },
            permisos_perfiles: [0],
            permisos: {
                headers: [{
                        text: "Categoría",
                        value: "categoria"
                    },
                    {
                        text: "Permiso",
                        value: "nombre"
                    }
                ]
            },
            subtipos: [],
            subtipoSelected: [],
            valoresCatalogo: [],
            valorSelected: "",
            subtipoUsuario: 0,
            subtipoHint: false
        };
    },    
    mounted: function () {
        this.getSubtipos();
        this.getGrupos();
        this.getUsuarios();
        this.getPerfiles();   
        this.getClientes();   
        this.getTiposUsuario();  
        this.model_filters = this.$refs.vuetable.query;
        //Para detectar el cambio de estatus por lista y que busque, sin darle enter
        const select = document.getElementsByName('vf__estatus')[0];
        const select2 = document.getElementsByName('vf__notificaciones')[0];
        select.addEventListener('change', this.onStatusChanged);
        select2.addEventListener('change', this.onStatusChanged);
    },
    watch: {
        model_filters: {
            handler(val) {
                this.pwPagination.options.filters = {
                    usuario: this.$local_storage.get("id_usuario"),
                    sistema: this.$sistema,
                    filtros: {                        
                        usuario__iniciales__icontains: this.model_filters.iniciales,
                        usuario__nombre__icontains: this.model_filters.nombre,
                        usuario__apellidos__icontains: this.model_filters.apellidos,
                        usuario__username__icontains: this.model_filters.email,
                        usuario__notificaciones: this.model_filters.notificaciones,
                        estatus: this.model_filters.estatus,
                        cliente__nombre__icontains: this.model_filters.cliente,
                        cliente__identificador__icontains: this.model_filters.cliente_rfc,
                    }
                }                
            },
            deep: true
        }        
    },
    methods: {
        onStatusChanged(event) {
            this.$nextTick(() => {
                this.$refs.pagination_pw.filterData();
            });                       
        },
        getTiposUsuario: function () {
            axios
                .post(this.$hostname + "tipos-usuarios/get_all/")
                .then(response => {
                    let datos = response.data.filter(function (tipo) {
                        return tipo.nombre == "Cliente";
                    });

                    this.tipos_usuario = datos;
                })
                .catch(error => {
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: "Ocurrió un error al obtener los tipos de usuario.",
                        footer: ""
                    });
                });
        },
        getNombrePerfil: function (perfil) {
            if (perfil !== null) return perfil.nombre;
        },
        getSubtipo: function (subtipo) {
            if (subtipo !== null) return subtipo;
            else return "Sin Seleccionar";
        },
        
        openModalPermisos: function (perfil) {
            if (perfil === null)
                this.$swal({
                    type: "error",
                    title: "¡Operación no Permitida!",
                    text: "El usuario no tiene un perfil asignado.",
                    footer: ""
                });
            else {
                this.titleModalPermisos = "Permisos del Perfil: " + perfil.nombre;
                this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
                let data = {
                    cliente: this.$local_storage.get("id_cliente"),
                    sistema: this.$sistema,
                    id_perfil: perfil.id
                };

                axios
                    .post(this.$hostname + "perfiles/get_permisos_perfil/", data)
                    .then(response => {
                        //console.log(response.data);

                        this.permisos_perfiles = this.filtrarPermisosActivos(response.data);
                        this.modal_permisos = true;
                    })
                    .catch(error => {
                        this.$swal({
                            type: "error",
                            title: "¡Operación no Permitida!",
                            text: "Ocurrió un error al obtener los permisos.",
                            footer: ""
                        });
                    })
                    .then(() => {
                        this.$root.$dialogLoader.hide();
                    });
            }
        },      
        openModalGrupo: function(id_usuario, nombre, apellidos){
            try {
                this.id_grupo = "";
                this.id_usuario_seleccionado = id_usuario;
                this.nombre_usuario_seleccionado = nombre +" "+ apellidos;
                this.modal_grupo = true;
            } catch (error) {
                console.log(error);
            }
        },  
        convertirUsuario: function(){
            if (this.$refs.formGrupo.validate()) {
                this.$swal({
                    type: "info",
                    title: "Atención",
                    text: "Al hacer el cambio, el usuario se deslindará de los clientes a los que está asociado y pertenecerá al grupo de clientes seleccionado. "+
                            "El usuario ya no será visible en esta lista. ¿Desea continuar?",
                    footer: "",
                    showCancelButton: true,
                    cancelButtonColor: "#d33",
                    confirmButtonColor: "#3085d6",
                    confirmButtonText: "Aceptar",
                    cancelButtonText: "Cancelar"
                }).then(result => {
                    if (result.value){
                        this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
                        let data = {
                            id_grupo: this.id_grupo,
                            id_usuario: this.id_usuario_seleccionado,
                        };                        
                            axios.post(this.$hostname + "clientes/convertir_agrupo/", data)
                            .then(response => {
                                this.$swal({
                                    type: "success",
                                    title: "Operación Exitosa",
                                    text: "El registro se actualizó correctamente.",
                                    footer: ""
                                });

                                this.modal_grupo = false;
                                this.$refs.pagination_pw.filterData();
                            })
                            .catch(error => {
                                var mensaje = "Ocurrió un error al actualizar el registro. Favor de comunicarse con soporte.";
                                if (typeof error.response != "undefined") {
                                    
                                    if (error.response.data != undefined){
                                        if (error.response.data.mensaje!=undefined)
                                            for(var k in error.response.data.mensaje)
                                                mensaje = error.response.data.mensaje[k];                                
                                    }
                                }
                                this.$swal({
                                    type: "error",
                                    title: "¡Operación no Permitida!",
                                    text: mensaje,
                                    footer: ""
                                });
                            })
                            .then(() => {
                                this.$root.$dialogLoader.hide();
                            });
                    }                    
                });
            }              
        },
        openModal: function (type) {
            if (type === 1) {
                this.title = "Nuevo Usuario";
                this.update = false;
                this.model.username = "";
                this.model.password = "";
                this.model.nombre = "";
                this.model.apellidos = "";
                this.model.iniciales = "";
                this.model.tipo_usuario = "";                
                this.model.perfil = "";
                this.model.notificaciones = "Pendiente";
            } else {
                this.title = "Actualizar Usuario";
                this.update = true;
            }

            this.modal = true;
        },
        openModalCliente: function(id_usuario, nombre, apellidos){
            try {
                this.id_cliente = "";
                this.id_usuario_seleccionado = id_usuario;
                this.nombre_usuario_seleccionado = nombre +" "+ apellidos;
                this.modal_cliente = true;
            } catch (error) {
                console.log(error);
            }
        },  
        convertirUsuarioCliente: function(){
            if (this.$refs.formCliente.validate()) {
                this.$swal({
                    type: "info",
                    title: "Atención",
                    text: "Se asignará la empresa/cliente seleccionada al usuario. ¿Desea continuar?",
                    footer: "",
                    showCancelButton: true,
                    cancelButtonColor: "#d33",
                    confirmButtonColor: "#3085d6",
                    confirmButtonText: "Aceptar",
                    cancelButtonText: "Cancelar"
                }).then(result => {
                    if (result.value){
                        this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
                        let data = {
                            id_cliente: this.id_cliente,
                            id_usuario: this.id_usuario_seleccionado,
                        };
                        axios.post(this.$hostname + "clientes/convertir_acliente/", data)
                            .then(response => {
                                this.$swal({
                                    type: "success",
                                    title: "Operación Exitosa",
                                    text: "El registro se actualizó correctamente.",
                                    footer: ""
                                });

                                this.modal_cliente = false;
                                this.$refs.pagination_pw.filterData();
                            })
                            .catch(error => {
                                var mensaje = "Ocurrió un error al actualizar el registro. Favor de comunicarse con soporte.";
                                if (typeof error.response != "undefined") {
                                    
                                    if (error.response.data != undefined){
                                        if (error.response.data.mensaje!=undefined)
                                            for(var k in error.response.data.mensaje)
                                                mensaje = error.response.data.mensaje[k];                                
                                    }
                                }
                                this.$swal({
                                    type: "error",
                                    title: "¡Operación no Permitida!",
                                    text: mensaje,
                                    footer: ""
                                });
                            })
                            .then(() => {
                                this.$root.$dialogLoader.hide();
                            });
                    }                    
                });
            }              
        },
        getSubtipos: function () {
            axios
                .get(this.$hostname + "subtipos/")
                .then(response => {
                    this.subtipos = response.data;
                })
                .catch(error => {
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: "Ocurrió un error al obtener el catálogo de subtipos.",
                        footer: ""
                    });
                });
        },        
        getClientes: function () {
            axios.get(this.$hostname + "clientes/")
                .then(response => {
                    this.clientes = response.data;

                    var clientesActivos = this.clientes.filter(cliente => {
                        return cliente.estatus == 1;
                    });

                    this.clientes = clientesActivos;                    
                })
                .catch(error => {                    
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: "Ocurrió un error al obtener los clientes.",
                        footer: ""
                    });
                });
        },
        getGrupos: function () {
            axios.get(this.$hostname + "grupos/")
                .then(response => {
                    this.grupos = response.data;                    
                })
                .catch(error => {
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: "Ocurrió un error al obtener los grupos.",
                        footer: ""
                    });
                });
        },
        
        filtrarPermisosActivos: function (arr) {
            return arr.filter(function (ele) {
                    return ele.activo == 1;
                }).sort(this.ordenarArrayPermisos);
        },
        ordenarArrayPermisos: function (a, b) {
            if (a.ordenar > b.ordenar) return 1;
            if (a.ordenar < b.ordenar) return -1;
            return 0;
        },
        getUsuarios: function () {            
            let data = {                
                sistema: this.$sistema
            };
            
            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
            axios
                .post(this.$hostname + "usuarios/getall_usuarios_clientes/", data)                
                .then(response => {                    
                    this.usuarios.items = response.data.results;
                    this.pwPagination.total = response.data.count;
                    this.pwPagination.links.next = response.data.next;
                    this.pwPagination.links.prev = response.data.previous;
                    this.$root.$dialogLoader.hide();
                })
                .catch(error => {
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: "Ocurrió un error al obtener los usuarios.",
                        footer: ""
                    });
                    this.$root.$dialogLoader.hide();
                });
        },
        exportar: function (url="") {  
            let self = this;          
            let data = {                
                sistema: this.$sistema,
                limit: 2000
            };

            var url_datos = this.$hostname + "usuarios/getall_usuarios_clientes/?limit=300";
            if(url != ""){
                url_datos = url;
            } else {
                this.aexportar = [];
            }
            
            this.$root.$dialogLoader.show('Generando el Reporte espere un momento por favor..');
            axios.post(url_datos, data)
                .then(response => {
                    var next = response.data.next;
                    var datos = response.data.results;
                    datos.forEach(function(item){
                        item.perfil = item.perfil == null?"Administrador": item.perfil.nombre;
                         item.estatus = item.estatus==1?"Activo":"Inactivo";
                         item.estatus_rfc = item.estatus_rfc==1?"Activo":  item.estatus_rfc==0 ? "Inactivo": 'Sin Asignar';
                    });

                    this.aexportar = this.aexportar.concat(datos);
                    
                    if(next){
                        this.exportar(next);
                    } else {
                        this.$root.$dialogLoader.hide();
                        self.modal_exportar = true;
                    }
                    
                })
                .catch(error => {
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: "Ocurrió un error al obtener los usuarios.",
                        footer: ""
                    });
                    console.log(error);
                    this.$root.$dialogLoader.hide();
                });
        },
        getPerfiles: function () {
            axios
                .get(this.$hostname + "perfiles/")
                .then(response => {

                    this.perfiles = response.data;
                })
                .catch(error => {
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: "Ocurrió un error al obtener los perfiles.",
                        footer: ""
                    });
                });
        }, 
        getPerfilesCliente: function (id_cliente) {

            let data = {
                "cliente": id_cliente
            };
            axios
                .post(this.$hostname + "perfiles/get_perfiles_cliente/", data)
                .then(response => {

                    this.perfiles = response.data;
                })
                .catch(error => {
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: "Ocurrió un error al obtener los perfiles.",
                        footer: ""
                    });
                });
        },                  
        
        resetPassword: function (id_usuario, cliente_id, email) {
            this.$swal({
                type: "info",
                title: "Cuidado",
                text: "¿Realmente desea resetear la contraseña?",
                footer: "",
                showCancelButton: true,
                cancelButtonColor: "#d33",
                confirmButtonColor: "#3085d6",
                confirmButtonText: "Aceptar",
                cancelButtonText: "Cancelar"
            }).then(result => {                

                let data = {
                    cliente: cliente_id,
                    sistema: this.$sistema,
                    password: email
                };

                if (result.value) {
                    this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');

                    axios
                        .put(this.$hostname + "usuarios/" + id_usuario + "/", data)
                        .then(response => {
                            this.$swal({
                                type: "success",
                                title: "Operación Exitosa",
                                text: "La contraseña se reseteó correctamente",
                                footer: ""
                            });
                        })
                        .catch(error => {
                            this.$swal({
                                type: "error",
                                title: "¡Operación no Permitida!",
                                text: "Ocurrió un error al resetear la contraseña",
                                footer: ""
                            });
                        }).then(() => {
                            this.$root.$dialogLoader.hide();
                        });
                }
            });
        },
        changeEstatus: function (id_usuario, id_usuario_cliente, estatus) {
            let msj = estatus ? "Activar" : "Desactivar";

            axios
                .get(this.$hostname + "usuarios/" + id_usuario + "/")
                .then(response => {
                    this.model = response.data;
                })
                .catch(error => {
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: "Ocurrió un error al obtener al usuario",
                        footer: ""
                    });
                });

            this.$swal({
                type: "question",
                title: "Cuidado",
                text: "¿Está seguro de " + msj + " el registro?",
                footer: "",
                showCancelButton: true,
                cancelButtonColor: "#d33",
                confirmButtonColor: "#3085d6",
                confirmButtonText: "Aceptar",
                cancelButtonText: "Cancelar"
            }).then(result => {                

                let data = {
                    estatus: estatus,
                    id_usuario_cliente: id_usuario_cliente
                };

                if (result.value) {
                    this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
                    axios
                        //Cambia el estatus de la tabla usuarios_clientes
                        .post(this.$hostname + "usuarios/cambiar_estatus/", data)                            
                        .then(response => {                            
                            this.$refs.pagination_pw.filterData();
                            this.$root.$dialogLoader.hide();
                            if (msj == 'Activar') {
                                this.showNotificacionUsuario(this.model.nombre, this.model.username);
                            }
                        })
                        .catch(error => {
                            this.$root.$dialogLoader.hide();
                            this.$swal({
                                type: "error",
                                title: "¡Operación no Permitida!",
                                text: "Ocurrió un error al actualizar el estatus al usuario",
                                footer: ""
                            });
                        });
                }
            });
        },

        showNotificacionUsuario(nombre, correo) {
            var fecha = moment(new Date()).format("DD/MM/YYYY");
            this.$swal({
                type: "info",
                title: "Notificación",
                html: "Se ha configurado acceso para el usuario:  <span style='font-weight: bold;'>" + nombre + "</span>, " +
                    "con cuenta de correo electrónico <span style='font-weight: bold;'>" + correo + "</span>, a partir de esta fecha: <span style='font-weight: bold;'>" + fecha + "</span>. " +
                    "Le sugerimos confirmar los permisos concedidos a través del módulo: 'PERFIL DE USUARIO' " +
                    "para concluir exitosamente con la cuenta habilitada. " +
                    "<br/><br/>Es responsabilidad de la empresa a través de su usuario 'Cliente-Administrador' el control de acceso a la plataforma, " +
                    "así como las actividades que puedan realizar conforme a su perfil autorizado.",
                footer: "",
                allowOutsideClick: false,
                allowEscapeKey: false,
                allowEnterKey: false,
                showCancelButton: false,
                confirmButtonText: "Aceptar",
            });
        },
        logout: function function_name(id_usuario) {
            var data = {
                usuario: id_usuario,
                sistema: this.$sistema,
                avatar: "undefined"
            };

            var url = this.$hostname + "usuarios/logout/";
            var self = this;

            axios
                .post(url, data)
                .then(function (response) {
                    self.$swal({
                        type: "success",
                        title: "Operación Exitosa",
                        text: "La sesión del usuario se cerró correctamente",
                        footer: ""
                    });
                })
                .catch(function (error) {
                    self.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: "Ocurrió un error al cerrar la sesión",
                        footer: ""
                    });
                });
        }, 
        getUsuario: async function (id_usuario, id_usuario_cliente) {
            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');

            var user = this.usuarios.items.find(e => e.id == id_usuario && e.id_usuario_cliente == id_usuario_cliente);
            if(user){
                await this.getPerfilesCliente(user.cliente_id);
                this.model.id_usuario = user.id;
                this.model.username = user.email;
                this.model.nombre = user.nombre;
                this.model.apellidos = user.apellidos;
                this.model.iniciales = user.iniciales;
                this.model.notificaciones = user.notificaciones;
                this.model.cliente = user.cliente_id;
                this.model.tipo_usuario = 1;
                this.model.id_usuario_cliente = id_usuario_cliente;

                if (user.perfil != undefined && user.perfil != null) {
                    this.model.perfil = user.perfil.id;
                    this.model.tipo_usuario = 2;
                }
                
                this.openModal(2);
            } else {
                this.$swal({
                    type: "error",
                    title: "¡Operación no Permitida!",
                    text: "Información no encontrada. Intente nuevamente.",
                    footer: ""
                });                
            }
            this.$root.$dialogLoader.hide();            
        },        
        updateUsuario: function () {
            
            if (this.$refs.form.validate()) {

                this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');

                let tipo = this.tipos_usuario.filter(function (tipo) {
                    return tipo.nombre == "Cliente";
                });

                if (this.model.tipo_usuario == 1) {//Si es Administrador, quitamos el perfil
                    this.model.perfil = "";
                }

                //Datos del usuario
                let data = {                    
                    nombre: this.model.nombre,
                    apellidos: this.model.apellidos,
                    iniciales: this.model.iniciales,                    
                    tipo_usuario: tipo[0].id_tipo_usuario,
                    sistema: this.$sistema,
                    cliente: this.model.cliente,                    
                    perfil: this.model.perfil==undefined?"":this.model.perfil, 
                    notificaciones: this.model.notificaciones==undefined?"":this.model.notificaciones,                   
                };

                axios
                    .put(this.$hostname + "usuarios/" + this.model.id_usuario + "/", data)                    
                    .then(response => {  
                        
                        var dataTipo = {
                            usuario: this.model.id_usuario,
                            tipo_usuario: tipo[0].id_tipo_usuario,
                            cliente: this.model.cliente
                        };

                        if (this.model.tipo_usuario == 2) dataTipo.perfil = this.model.perfil;

                        axios
                            .put(this.$hostname + "usuarios/cambiar_tipo_usuario/", dataTipo)
                            .then(responseTipo => {    
                                this.$swal({
                                    type: "success",
                                    title: "Operación Exitosa",
                                    text: "El usuario se actualizó correctamente.",
                                    footer: ""
                                });                            
                            })
                            .catch(error => {
                                let msj = error.response.data.mensaje;

                                if (msj === undefined) msj = error.response.data.username;

                                this.$swal({
                                    type: "error",
                                    title: "¡Operación no Permitida!",
                                    text: msj,
                                    footer: ""
                                });
                            });
                        
                        
                    })
                    .catch(error => {
                        this.$root.$dialogLoader.hide();
                        if (typeof error.response != "undefined") {
                            let msj = error.response.data.detail;
                            if (msj === undefined) msj = error.response.data.username;

                            this.$swal({
                                type: "error",
                                title: "¡Operación no Permitida!",
                                text: msj,
                                footer: ""
                            });
                        } else {
                            console.log(error);
                        }
                    }).then(() => {
                        this.$root.$dialogLoader.hide();
                        this.modal = false;
                        this.$refs.pagination_pw.filterData();
                    });

                
            }
        },
    }
};
</script>
